export const GET_DASHBOARD_SELECT_RESPONSIBLE_VACANTES = 'GET_DASHBOARD_SELECT_RESPONSIBLE_VACANTES';
export const LOADING_DASHBOARD_SELECT_RESPONSIBLE_VACANTES = 'LOADING_DASHBOARD_SELECT_RESPONSIBLE_VACANTES';
export const DASHBOARD_SELECT_ERROR_VACANTES = 'DASHBOARD_SELECT_ERROR_CONTRATACIONES_VACANTES';